<template>
	<div class="box">
		<div class="icon">
			<i class="layui-icon layui-icon-ok-circle" style="color: rgb(229, 28, 35); font-size: 300px;"></i>
		</div>
		<p class="text">添加成功</p>
		<p class="time">{{ss}}秒后自动跳转到购物车页面</p>
		<div class="btn-box">
			<button class="btn1" @click="creatOrder">继续下单</button>
			<button class="btn2" @click="shopCar">查看购物车</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				ss: 5,
				t: ''
			}
		},
		created() {
			let _this = this;
			this.t = setInterval(function(){
				if(_this.ss == 0) {
					clearInterval(_this.t);
					_this.$router.replace({
						path: '/shopCar'
					})
				} else{
					_this.ss -= 1;
				}
			},1000)
		},
		mounted() {

		},
		destroyed: function() {　　　
			clearInterval(this.t);
		},
		methods: {
			creatOrder() {
				clearInterval(this.t);
				this.$router.replace({
					path: '/creatOrder'
				})
			},
			shopCar() {
				clearInterval(this.t);
				this.$router.replace({
					path: '/shopCar'
				})
			},
		},
	}
</script>

<style scoped="scoped">
	.time {
		text-align: center;
		margin: 25px auto;
		font-size: 16px;
		color: #4876FF;
	}
	
	.box {
		width: 600px;
		background: #fff;
		margin: 0 auto;
		padding: 50px 0 0;
	}
	
	.icon {
		text-align: center;
	}
	
	.text {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
	}
	
	.btn-box {
		margin: 30px auto;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.btn-box .btn1 {
		width: 200px;
		height: 40px;
		border-radius: 10px;
		border: none;
		text-align: center;
		line-height: 40px;
		color: #fff;
		background-color: rgb(72, 118, 255);
	}
	
	.btn-box .btn2 {
		width: 200px;
		height: 40px;
		border-radius: 10px;
		border: none;
		text-align: center;
		line-height: 40px;
		color: #fff;
		background-color: rgb(255, 152, 0);
	}
</style>


// WEBPACK FOOTER //
// src/components/success.vue